<template>
    <div>
        <div class="section-title">
            <div class="line"></div>
            <div>我的优惠券</div>
        </div>

        <div class="coupon-tabs">
            <div class="tab-item" :class="{ active: activeTab === '1' }" @click="switchTab('1')">全部</div>
            <div class="tab-item" :class="{ active: activeTab === '2' }" @click="switchTab('2')">未使用</div>
            <div class="tab-item" :class="{ active: activeTab === '4' }" @click="switchTab('4')">已过期</div>
        </div>

        <div class="coupons-grid">
            <div class="coupon-item" v-for="(coupon, index) in coupons" :key="index"
                :class="coupon.status == '1' ? '' : 'expired'">
                <div class="coupon-left">
                    <div class="coupon-amount">¥{{ coupon.money }}</div>
                    <!-- <div class="coupon-condition">满{{ coupon.content }}</div> -->
                </div>
                <div class="coupon-right">
                    <div style="display: flex; justify-content: space-between; align-items: center;">
                        <div>
                            <div class="coupon-name">{{ coupon.content }}</div>
                            <!-- <div class="coupon-scope">{{ coupon.scope }}</div> -->
                        </div>
                        <button class="coupon-button">{{ coupon.status === '1' ? '未使用' : coupon.status === '3' ?
                            '已使用' : '已过期' }}</button>
                    </div>
                    <div class="coupon-expiry">有效期: {{ coupon.end_time }}</div>
                </div>
            </div>
        </div>

        <!-- <div v-else>
            <el-empty description="暂无优惠券"></el-empty>
        </div> -->

    </div>
</template>

<script>
export default {
    name: 'MyCoupons',
    data() {
        return {
            activeTab: '1',
            coupons: [

            ]
        }
    },
    computed: {

    },

    mounted() {
        this.getCouponList()
    },
    methods: {
        switchTab(tab) {
            this.activeTab = tab;
            this.getCouponList()
        },


        // 获取优惠券列表
        getCouponList() {
            this.$dapi.getCouponList({
                type: this.activeTab === '1' ? '' : this.activeTab
            }).then(res => {
                this.coupons = res || [];

                console.log(this.coupons);

            });
        },
    }
}
</script>

<style scoped>
.member-center {
    background-color: #f5f5f5;
    padding: 20px;
    min-height: 100vh;
}

.center-container {
    background-color: #ffffff;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.section-title {
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 600;
    color: #333333;
}

.coupon-tabs {
    display: flex;
    margin-bottom: 20px;
    border-bottom: 1px solid #e8e8e8;
}

.tab-item {
    padding: 10px 20px;
    margin-right: 20px;
    cursor: pointer;
    color: #666;
    font-size: 14px;
    border-bottom: 2px solid transparent;
}

.tab-item.active {
    color: #1890ff;
    border-bottom-color: #1890ff;
}

.coupons-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.coupon-item {
    display: flex;
    border-radius: 8px;
    overflow: hidden;
    color: #fff;
    position: relative;
    background-image: url('~@/assets/images/58.png');
    height: 120px;
    background-size: cover;
    background-position: center;
}

.coupon-item.used,
.coupon-item.expired {
    background-image: url('~@/assets/images/59.png');
}

.coupon-item::before {
    content: '';
    position: absolute;
    top: 0;
    right: -10px;
    width: 20px;
    height: 100%;
    background: radial-gradient(circle, transparent 50%, #fff 50%) 0 0 repeat-y;
    background-size: 20px 20px;
}

.coupon-left {
    width: 128px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.coupon-amount {
    font-size: 26px;
    font-weight: bold;
    line-height: 1;
    margin-bottom: 5px;
}

.coupon-condition {
    font-size: 12px;
    opacity: 0.9;
}

.coupon-right {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    flex: 1;
    padding: 15px;
    position: relative;
    color: #333;
}

.coupon-name {
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 5px;
    text-align: left;
}

.coupon-scope {
    font-size: 12px;
    opacity: 0.9;
    margin-bottom: 10px;
    text-align: left;
}

.coupon-expiry {
    font-size: 12px;
    opacity: 0.8;
    text-align: left;
}

.coupon-button {
    width: 80px;
    height: 32px;
    border-radius: 16px 16px 16px 16px;
    border: 1px solid #2563E5;
    font-weight: 400;
    font-size: 16px;
    color: #286CED;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .coupons-grid {
        grid-template-columns: 1fr;
    }

    .coupon-left {
        flex: 0 0 100px;
    }

    .coupon-amount {
        font-size: 24px;
    }
}

.line {
    display: block;
    width: 4px;
    height: 18px;
    background-color: #286CED;
    border-radius: 2px;
    margin-right: 12px;
}
</style>